<template>
  <div class="message-search-results">
    <div v-if="loading" class="p-m text-center">
      <spinner :inline="true"></spinner>
    </div>
    <div v-else-if="hasResults">
      <div v-for="result in results" :key="resultKey(result)">
        <div class="hr-line-dashed"></div>
        <!-- Message group result -->
        <a v-if="result.type === 'message_group'"
           :href="'/message_groups/' + result.id"
           class="flex align-items-center search-result gap-x-sm p-x-sm"
           data-cy="search-result">
          <div>
            <h3 class="m-b-none message-snippet" v-html="highlightText(result.name)"></h3>
            <p v-if="result.teaser" class="text-14 text-gray-500 m-b-none">{{ result.teaser }}</p>
          </div>
        </a>
        <!-- Message result -->
        <a v-else
           :href="'/message_groups/' + result.message_group_id + '?message_id=' + result.id"
           class="flex flex-col search-result gap-y-xxs p-x-sm"
           data-cy="search-result">
          <div class="flex align-items-center gap-x-xs">
            <span class="text-12 font-semi">{{ result.author.name }}</span>
            <span class="text-12 text-gray-400">in</span>
            <span class="text-12 font-semi">{{ result.message_group_name }}</span>
          </div>
          <p class="text-14 m-b-none message-snippet" v-html="result.snippet"></p>
          <span class="text-12 text-gray-400">{{ formatDate(result.created_at) }}</span>
        </a>
      </div>
    </div>
    <div v-else-if="searched" class="p-m text-center">
      <p class="text-gray-500 m-b-none">No results found</p>
    </div>
  </div>
</template>

<script>
import Spinner from './spinner.vue';

export default {
  name: 'message-search-results',
  components: {
    Spinner,
  },
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searched: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasResults() {
      return this.results.length > 0;
    },
  },
  methods: {
    resultKey(result) {
      return `${result.type}-${result.id}`;
    },
    highlightText(text) {
      if (!this.query || !text) return _.escape(text);
      // Escape HTML entities first to prevent XSS, then wrap matches in <mark>
      const safeText = _.escape(text);
      const safeQuery = _.escape(this.query).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${safeQuery})`, 'gi');
      return safeText.replace(regex, '<mark>$1</mark>');
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays === 0) {
        return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      } if (diffDays < 7) {
        return date.toLocaleDateString([], { weekday: 'short' });
      }
      const options = { month: 'short', day: 'numeric' };
      if (date.getFullYear() !== now.getFullYear()) {
        options.year = 'numeric';
      }
      return date.toLocaleDateString([], options);
    },
  },
};
</script>
